import find from 'lodash/find';

import { datadogLogs } from 'root/datadog/datadogLogs';
import { datadogRum } from 'root/datadog/datadogRum';
import Monitoring from 'shared_modules/Monitoring';

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
// @ts-expect-error
window.merchantos = {
  debug(msg) {
    if (window.config.debug_on === true) {
      // eslint-disable-next-line no-console
      console.log(msg);
    }
  },

  /**
   * Log that an Error occurred
   * @param error {Error|XMLHeaderRequest|String}
   * @param optionalMsg {String} optional context string
   */
  error(error, optionalMsg) {
    window.merchantos.debug((optionalMsg ? `${optionalMsg} ` : '') + error);
    Monitoring.addError(error as Error);
  },

  session: {
    getSystemCustomerID() {
      return window.merchantos.session.sessData?.systemCustomerID || null;
    },
    getSystemCustomerName() {
      return window.merchantos.session.sessData?.systemCustomerName ?? null;
    },
    getSystemUserID() {
      return window.merchantos.session.sessData?.systemUserID || null;
    },
    getEmployee() {
      return window.merchantos.session.sessData?.Employee || null;
    },
    getShop() {
      return window.merchantos.session?.sessData?.Shop || null;
    },
    getRegister() {
      return window.merchantos.session.sessData?.Register || null;
    },
    hasRight(right) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      if (!this.sessData || this.sessData.Rights[right] !== 'true') {
        return false;
      }
      return true;
    },
    getAccountStatus: () => {
      if (!window.merchantos.account) return null;
      return window.merchantos.account.status;
    },
    isReadOnly() {
      return (
        window.merchantos.session.sessData?.readOnly === 'true' ||
        window.merchantos.session.sessData?.readOnly === true
      );
    },
    sessData: null,
    moduleRequestFunc() {
      return window.merchantos.session.apiRequest(
        '/API/SystemCustomerModule.json?systemCustomerID={{systemCustomerID}}&load_relations=all&readonly=1'
      );
    },
    systemModuleCacher: null,

    init() {
      const deferred = $.Deferred();

      if (window.merchantos.session.initCache) {
        // already loaded, just return a success
        return deferred.resolve(
          window.merchantos.session.initCache[0],
          window.merchantos.session.initCache[1],
          window.merchantos.session.initCache[2]
        );
      }

      if (!window.merchantos.session.initCacheRequests.length) {
        window.merchantos.session
          .apiRequest('/API/Session.json')
          .done((mSess, textStatus, jqXHR) => {
            window.merchantos.session.initCache = [mSess, textStatus, jqXHR];
            window.merchantos.session.sessData = mSess;

            // eslint-disable-next-line array-callback-return
            window.merchantos.session.initCacheRequests.map((deferred) => {
              deferred.resolve(mSess, textStatus, jqXHR);
            });

            window.merchantos.session.initCacheRequests = [];

            // Initialize a request cacher for SystemCustomerModule API calls.
            // We'll leverage sessionStorage as the cache backing and it will invalidate every 5 minutes
            const expiration = 300000; // 5 minutes
            const ssCache = window.merchantos.cached_request.SessionStorageCache;
            const requestFunc = window.merchantos.session.moduleRequestFunc;

            window.merchantos.session.systemModuleCacher =
              new window.merchantos.cached_request.CachedAsyncRequest(
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '() => Deferred<any, any, any>' i... Remove this comment to see the full error message
                requestFunc,
                expiration,
                ssCache
              );

            if (window.isGriffin()) {
              // set the shop and register for Stencil Web API
              window.StencilWebAPI.shop.setShop(
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
                window.merchantos.session.getShop()
                  ? // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                    window.merchantos.session.getShop().shopID
                  : null
              );
              window.StencilWebAPI.shop.setRegister(
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
                window.merchantos.session.getRegister()
                  ? // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                    window.merchantos.session.getRegister().registerID
                  : null
              );
            }
            window.merchantos.session.updateLoggerGlobalContext();
          });
      }

      window.merchantos.session.initCacheRequests.push(deferred);

      return deferred;
    },
    updateLoggerGlobalContext() {
      try {
        const user = {
          id: String(window.merchantos.session.getSystemUserID()),
        };
        datadogRum.setUser(user);
        datadogLogs.setUser(user);
      } catch (e) {
        console.error('Error updating logger user context');
      }
      try {
        const context = {
          accountID: window.merchantos.session.getSystemCustomerID(),
          shopID: window.merchantos.session.getShop()?.shopID,
          employeeID: window.merchantos.session.getEmployee()?.employeeID,
          registerID: window.merchantos.session.getRegister()?.registerID,
          registerName: window.merchantos.session.getRegister()?.name,
          isAdmin: window.merchantos.session.hasRight('admin') ? 1 : 0,
        };
        datadogRum.setGlobalContext(context);
        datadogLogs.setGlobalContext(context);
      } catch (e) {
        console.error('Error updating logger global context');
      }
    },
    initCache: null,
    initCacheRequests: [],
    clearCache() {
      window.merchantos.session.initCache = null;
    },
    apiRequest(url, load_relations) {
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      url = url.replace('{{systemCustomerID}}', window.merchantos.session.getSystemCustomerID());
      load_relations = load_relations ? `&load_relations=${JSON.stringify(load_relations)}` : '';

      const deferred = $.Deferred();

      $.getJSON(url + load_relations)
        .fail(function onGetFail(jqXHR, textStatus, errorThrown) {
          window.merchantos.debug(errorThrown);
          // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
          deferred.rejectWith(this, [jqXHR, textStatus, errorThrown]);
        })
        .done(function onGetDone(data, textStatus, jqXHR) {
          // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
          deferred.resolveWith(this, [data, textStatus, jqXHR]);
        });

      return deferred;
    },
    loadModules() {
      // Leverage the cached request if we have one
      if (window.merchantos.session.systemModuleCacher) {
        const custID = window.merchantos.session.getSystemCustomerID();
        return window.merchantos.session.systemModuleCacher.getResponse(custID as string);
      }

      // Otherwise make the API call
      return this.moduleRequestFunc();
    },
    getModule(moduleName) {
      const deferred = $.Deferred();

      window.merchantos.session
        .loadModules()
        .done((sysModules) => {
          let moduleData = null;
          // the Retail API doesn't consistently return arrays for a listing so handle the
          // case of where a single result is returned specially
          if (sysModules && Array.isArray(sysModules.SystemCustomerModule)) {
            moduleData = find(
              sysModules.SystemCustomerModule,
              (sysModule) => sysModule.SystemModule.name === moduleName
            );
          } else if (sysModules && typeof sysModules.SystemCustomerModule === 'object') {
            moduleData =
              sysModules.SystemCustomerModule.SystemModule.name === moduleName
                ? sysModules.SystemCustomerModule
                : null;
          }

          deferred.resolve(moduleData);
        })
        .fail(() => deferred.reject());

      return deferred.promise();
    },
    loadSale(saleID, relations) {
      return window.merchantos.session.apiRequest(
        `/API/Account/{{systemCustomerID}}/Sale/${saleID}.json?`,
        relations
      );
    },
    ecomSystemIntegrationID: null,
    ecomIntegration: null,
    getEcomIntegration() {
      const $system_integration_deferred = $.Deferred();
      const $ecom_integration_deferred = $.Deferred();

      if (window.merchantos.session.ecomSystemIntegrationID) {
        $system_integration_deferred.resolve();
      } else {
        window.lsCloud.getJSONFromAPI('/API/SystemIntegration.json').then((data) => {
          let data_system_integration = data.SystemIntegration;
          if (!Array.isArray(data_system_integration)) {
            data_system_integration = [data_system_integration];
          }

          const systemIntegrationDescription = 'Lightspeed eCom Connector';
          const ecomSystemIntegrations: SystemIntegration[] = data_system_integration.filter(
            ({ description = '' }) => description.startsWith(systemIntegrationDescription)
          );

          window.merchantos.session.ecomSystemIntegrationID = ecomSystemIntegrations.map(
            ({ systemIntegrationID }) => systemIntegrationID
          );

          $system_integration_deferred.resolve();
        });
      }
      $.when($system_integration_deferred).done(() => {
        if (window.merchantos.session.ecomIntegration) {
          $ecom_integration_deferred.resolve(window.merchantos.session.ecomIntegration);
        } else {
          window.lsCloud
            .getJSONFromAPI(
              `/API/Account/${window.merchantos.session.getSystemCustomerID()}/Integration.json`
            )
            .then((data) => {
              if (typeof data.Integration !== 'undefined') {
                let data_integration: Integration[] = data.Integration;
                if (!Array.isArray(data_integration)) {
                  data_integration = [data_integration];
                }

                window.merchantos.session.ecomIntegration =
                  data_integration.find(({ systemIntegrationID }) =>
                    window.merchantos.session.ecomSystemIntegrationID?.includes(systemIntegrationID)
                  ) || null;
              }

              $ecom_integration_deferred.resolve(window.merchantos.session.ecomIntegration);
            });
        }
      });

      return $ecom_integration_deferred;
    },

    /**
     * Calls image usage api to check if user has reached limit
     *
     */
    imageUsage: null,
    getImageUsage() {
      const $deferred = $.Deferred();

      if (window.merchantos.session.imageUsage) {
        $deferred.resolve();
      } else {
        const url = `API/Account/${window.merchantos.session.getSystemCustomerID()}/Image/Usage`;
        window.lsCloud.getJSONFromAPI(url).done((data) => {
          window.merchantos.session.imageUsage = data;
          $deferred.resolve();
        });
      }

      return $deferred;
    },
  },

  loadStatusPage: function loadStatusPageFunc(successFunction) {
    let timer: number;

    // Check to see if the staus page JS has been loaded already.
    if (!window.StatusPage) {
      (() => {
        const sp = document.createElement('script');
        sp.type = 'text/javascript';
        sp.async = true;
        sp.src = 'https://cdn.statuspage.io/se-v2.js';
        const s = document.getElementsByTagName('script')[0];
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        s.parentNode.insertBefore(sp, s);
      })();
    }

    function _statusPageIntervalFunc() {
      // When StatusPage is loaded, clear the timer and show the status
      if (!window.StatusPage) {
        return;
      }

      clearInterval(timer);

      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      // eslint-disable-next-line new-cap
      const statusPage = new window.StatusPage.page({ page: 'vlmmyqh2vn20' });
      statusPage.components({
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
        success(data) {
          if (!data || !data.components || !Array.isArray(data.components)) return;

          const componentIds = {
            retailPOS: 'ysf3ngmj29n7',
            retailAPI: 'jrjldh297tb0',
          };
          let statusIndex = 0;
          const statuses = [
            'operational',
            'degraded_performance',
            'partial_outage',
            'major_outage',
          ];
          const ids = [componentIds.retailPOS, componentIds.retailAPI];

          // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'component' implicitly has an 'any' type... Remove this comment to see the full error message
          data.components.forEach((component) => {
            if (ids.indexOf(component.id) === -1) return;

            const componentStatusIndex = statuses.indexOf(component.status);
            if (componentStatusIndex > statusIndex) {
              statusIndex = componentStatusIndex;
            }
          });

          successFunction(statuses[statusIndex]);
        },
      });
    }

    // Wait for StatusPage to load
    timer = window.setInterval(_statusPageIntervalFunc, 100);
  },
};
